import { render } from "./SolarLocation.vue?vue&type=template&id=b28339f4&scoped=true"
import script from "./SolarLocation.vue?vue&type=script&lang=js"
export * from "./SolarLocation.vue?vue&type=script&lang=js"

import "./SolarLocation.vue?vue&type=style&index=0&id=b28339f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28339f4"]])

export default __exports__